<div class="flex flex-col w-full rounded-md border border-proffeo-overlay-subtle bg-proffeo-surface">
  @if (companyGroup()) {
    <div
      [ngClass]="{
        'border-b border-proffeo-overlay-subtle rounded-t-md': hasChildGroups() && expanded()
      }"
      class="flex w-full justify-between items-center p-2 group hover:bg-proffeo-surface-muted transition-default"
    >
      <div class="flex gap-2.5 items-center">
        <mat-icon
          (click)="toggleExpanded()"
          [fontIcon]="expanded() ? 'stat_minus_1' : 'chevron_forward'"
          class="cursor-pointer hover:icon-accent transition-default"
        />
        <mat-icon
          fontIcon="domain"
          class="icon-lg"
        />
        <p class="text-lg text-proffeo-text max-md:text-base">{{ companyGroup().name }}</p>
        <div
          class="opacity-0 hidden md:flex pointer-events-none transition-all transition-150 gap-1.5 items-center group-hover:opacity-100 group-hover:pointer-events-auto"
        >
          <mat-icon
            (click)="openCreateCompanyGroupDialog(companyGroup().id)"
            fontIcon="add_box"
            class="hover:icon-danger! transition-all transition-150 cursor-pointer"
          />
        </div>
      </div>
      <div class="flex items-center">
        @if (companyGroup().parentGroupId) {
          @if (companyGroup().users()?.length > 0) {
            <proffeo-avatar
              (click)="selectGroupAdmin($safeNavigationMigration(groupAdmin()?.applicationUser()))"
              [user]="$safeNavigationMigration(groupAdmin()?.applicationUser())"
              [size]="AvatarSize.SM"
              [style.z-index]="companyGroup().users().length"
              [borderType]="AvatarBorderType.IndustryAdmin"
            />

            @if (groupUsers().length) {
              <proffeo-group-avatars
                (click)="selectUsers(companyGroup().users(), undefined, companyGroup().id)"
                [groupUsers]="groupUsers()"
                [showAvatarsCount]="3"
                [avatarSize]="AvatarSize.SM"
                class="cursor-pointer sm:ml-4"
              />
            }
          } @else {
            <proffeo-avatar
              (click)="selectUsers(companyGroup().users(), undefined, companyGroup().id)"
              [size]="AvatarSize.SM"
              class="sm:ml-2"
            />
          }
        }
      </div>
      <div
        [matMenuTriggerFor]="actionsMenu"
        class="items-center justify-center p-1 cursor-pointer max-md:flex hidden"
      >
        <mat-icon fontIcon="more_vert" />
      </div>
    </div>
    @if (expanded()) {
      @for (group of groupChildren(); track group().id) {
        <proffeo-company-groups-list-item [companyGroup]="group()"></proffeo-company-groups-list-item>
      }
    }
  }
</div>

<mat-menu #actionsMenu="matMenu">
  <div class="flex flex-col">
    <div
      (click)="openCreateCompanyGroupDialog(companyGroup().id)"
      class="flex w-full px-3 py-1.5 gap-1.5 items-center group hover:bg-proffeo-accent cursor-pointer"
    >
      <mat-icon
        fontIcon="add_box"
        class="group-hover:icon-white transition-all transition-150 cursor-pointer"
      />
      <p class="group-hover:icon-white">{{ 'groups-add-subgroup' | translate }}</p>
    </div>
  </div>
</mat-menu>
